import type { AllTokens } from '@/types/responses'

import esriId from '@arcgis/core/identity/IdentityManager'

const LOCALHOST_TOKENS = {
  'https://gs-prv.praha.eu/imgs/rest/services/': import.meta.env.VITE_GSPRV_LOCALHOST_TOKEN || '',
  'https://www.arcgis.com/sharing/rest/': import.meta.env.VITE_AGOL_LOCALHOST_TOKEN || '',
  'https://gp-dc.iprpraha.cz/arcgis/rest/services': import.meta.env.VITE_GPDC_LOCALHOST_TOKEN || '',
}

export async function assignTokens() {
  window.app.tokens = await fetchTokens()
  for (const server in window.app.tokens) {
    esriId.registerToken({
      server: server,
      token: window.app.tokens[server as keyof typeof window.app.tokens] as string,
    })
  }
}

export function getTokenForUrl(url: string) {
  if (!window.app.tokens) return null
  for (const server in window.app.tokens) {
    if (url.includes(server)) {
      return window.app.tokens[server as keyof typeof window.app.tokens] as string
    }
  }
  return null
}

export function addTokenToUrl(url: string) {
  if (!window.app.tokens) return url
  for (const server in window.app.tokens) {
    if (url.includes(server)) {
      if (url.includes('?')) {
        url = url + `&token=${window.app.tokens[server as keyof typeof window.app.tokens]}`
      } else {
        url = url + `?token=${window.app.tokens[server as keyof typeof window.app.tokens]}`
      }
    }
  }
  return url
}

async function fetchTokens() {
  if (window.location.hostname === 'localhost') {
    return LOCALHOST_TOKENS
  }
  const protocol = window.location.host.split('.')[0]
  try {
    const response = await fetch('https://geoportalpraha.cz/backend/get-tokens')
    const data = (await response.json()) as AllTokens
    if (data[protocol as string]) {
      return data[protocol as string] || LOCALHOST_TOKENS
    }
  } catch (error) {
    console.log(error)
  }
}
